import React, { DispatchWithoutAction, FC, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { FormProvider } from 'react-hook-form';
import { Site } from './dto/Site';
import { useSitesEditForm } from './hooks/useSitesEditForm';
import ModalContext from 'react-bootstrap/ModalContext';
import { SiteDto } from './dto/SiteDto';
import { api } from '../functions/api';
import { ApiPath } from '../api/ApiPath';
import { useSaveItem } from '../hooks/useSaveItem';
import { useTranslation } from 'react-i18next';
import { FormModalFooter } from '../components/form/FormModalFooter';
import { ModalHeader } from '../components/form/ModalHeader';
import { SiteFormBody } from './SiteFormBody';

interface Props {
  update: DispatchWithoutAction;
  site: Site;
}

export const SitesEdit: FC<Props> = ({ update, site }) => {
  const { t } = useTranslation();
  const form = useSitesEditForm(site);
  const { onHide } = useContext(ModalContext);

  const save = useSaveItem<SiteDto>((data) =>
    api({
      url: ApiPath.Site.replace(':id', site.id),
      method: 'patch',
      data,
    }),
  );

  const onSubmit = (data: SiteDto) => {
    save(data).then(() => {
      update();
      onHide();
    });
  };

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <ModalHeader>{t('Edit site')}</ModalHeader>
        <SiteFormBody />
        <FormModalFooter />
      </Form>
    </FormProvider>
  );
};
